import { html, LitElement, css, unsafeCSS, render } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import styles from './notificationGroup.scss?inline';

export default class SotbitNotificationGroup extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {};

    constructor() {
        super();
        this.options = {
            durationShow: 300,
            durationHide: 300,
            durationVisible: 2500,
        };

        this.classPrimary = 'primary';
        this.classSecondary = 'secondary';
    }

    _setClasses = () => {
        const slotElement = this.shadowRoot.querySelector('slot');
        const assignedNodes = slotElement.assignedNodes({ flatten: true });
        if (Array.isArray(assignedNodes) && assignedNodes.length) {
            assignedNodes.forEach((el, index) => {
                if (index !== assignedNodes.length - 1) {
                    el.classList.add(this.classSecondary);
                    el.classList.remove(this.classPrimary);
                    return;
                }

                el.classList.add(this.classPrimary);
                el.classList.remove(this.classSecondary);
            });
        }
    };

    addNotification(message, type) {
        const element = document.createElement('sotbit-notification');

        if (type) {
            element.setAttribute('status', type);
        }

        element.addEventListener('click', (e) => {
            if (e.target.tagName.toUpperCase() === 'A') {
                e.stopPropagation();
            }
        });

        const content = html` <span slot="message">${unsafeHTML(message)}</span> `;

        render(content, element);

        this.appendChild(element);

        const TOP_OFFSET = 160;

        const animation = element.animate(
            [
                {
                    transform: `translateY(-${TOP_OFFSET}px)`,
                },
                {
                    transform: `translateY(0px)`,
                },
            ],
            {
                duration: this.options.durationShow,
                easing: 'cubic-bezier(0.33, 1, 0.68, 1)',
            }
        );

        animation.onfinish = () => {
            this._setClasses();
            element.addEventListener('click', () => {
                this._hideNotification({
                    element,
                    duration: this.options.durationHide,
                });
            });

            setTimeout(() => {
                this._hideNotification({
                    element,
                    duration: this.durationHide,
                });
            }, this.options.durationVisible);
        };
    }

    _hideNotification(options) {
        if (!options.element) {
            return false;
        }

        options.element.remove();
        this._setClasses();
    }

    render() {
        return html` <slot></slot> `;
    }
}
